



























































































import { appModule } from "@/store/modules/app";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { storeBed } from "@/store/modules/bed";
import { userModule } from "@/store/modules/user";
import DataBed from "@/services/DataBed";
@Component({
  components: {},
})
export default class ModalListBookingByRM extends Vue {
  @Prop() readonly value!: boolean;
  rm = "";
  get headers() {
    const head = [
      {
        text: "NO",
        value: "nomor",
        width: "5vh",
        align: "left",
      },
      {
        text: "RM",
        value: "pasien.cm_dash",
        width: "10vh",
        align: "left",
      },
      {
        text: "Nama",
        value: "pasien.nama",
        align: "left",
      },
      {
        text: "Bangsal",
        value: "bed.unit",
        align: "left",
      },
      {
        text: "Kelas",
        value: "kelas.nama",
        width: "10vh",
        align: "left",
      },
      {
        text: "Catatan Pemesanan",
        value: "catatan",
        align: "left",
      },
      {
        text: "Hapus",
        value: "hapus",
        width: "10vh",
        align: "center",
      },
    ];
    return head;
  }
  get listBooking() {
    return storeBed.bookingRm;
  }

  close() {
    storeBed.actClearBooking();
    this.rm = "";
    this.show = false;
  }

  dataBk(cm) {
    storeBed.actClearBooking();
    storeBed.actBookingRm(cm);
  }

  hapus(val) {
    const dt = DataBed.deleteBooking(val.id, this.user["pegawai_id"]);
    dt.then((dt) => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        appModule.NoticeDelay("Berhasil Hapus Pemesanan Kamar");
        storeBed.actBookingRm(this.rm);
      }
    });
  }

  rmSubstr(val) {
    return val.substr(2, 6);
  }

  get user() {
    return userModule.user;
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
